// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationPatientDetails {
    static getAttributeTypeMap() {
        return ClaimAdjudicationPatientDetails.attributeTypeMap;
    }
}
ClaimAdjudicationPatientDetails.discriminator = undefined;
ClaimAdjudicationPatientDetails.additionalProperties = false;
ClaimAdjudicationPatientDetails.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "BasicEnrollmentGender"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "streetAddress",
        "baseName": "streetAddress",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=claimAdjudicationPatientDetails.js.map